
import mapMarkerSavedBoardIcon from 'assets/icons/new-map-marker-2.svg'
import mapMarkerPinIcon from 'assets/icons/new-map-marker.svg'
import mapLocationIcon from 'assets/icons/mapLocation.svg'
import { Icon } from 'leaflet'

export const mapLocation = new Icon({
  iconUrl: mapLocationIcon,
  iconAnchor: [15, 25],
  iconSize: [30, 50],
})

export const mapMarkerPin = new Icon({
  iconUrl: mapMarkerPinIcon,
  iconAnchor: [26, 25],
  iconSize: [50, 70]
});

export const mapMarkerSavedBoard = new Icon({
  iconUrl: mapMarkerSavedBoardIcon,
  iconAnchor: [15, 25],
  iconSize: [50, 70]
})